// extracted by mini-css-extract-plugin
export default {"section":"Aside_section__TXKJM","divider":"Aside_divider__p3NHm","menuIcon":"Aside_menuIcon__BPiFX"};